
import React from "react";

const solucoes = [
  {
    numero: "01",
    icone: "fa-laptop-code",
    titulo: "Sistemas personalizados",
    descricao:
      "Sistemas desenvolvidos conforme os processos da sua empresa, com foco em organização, produtividade e controle.",
    tags: ["Gestão", "Automação", "Controle"],
  },
  {
    numero: "02",
    icone: "fa-globe",
    titulo: "Aplicações web",
    descricao:
      "Plataformas acessíveis pela internet para conectar informações, simplificar tarefas e facilitar a gestão.",
    tags: ["Web", "Nuvem", "Integração"],
  },
  {
    numero: "03",
    icone: "fa-mobile-alt",
    titulo: "Aplicativos mobile",
    descricao:
      "Aplicativos pensados para aproximar sua empresa dos clientes e levar funcionalidades importantes para o celular.",
    tags: ["Android", "Mobilidade", "Praticidade"],
  },
  {
    numero: "04",
    icone: "fa-cogs",
    titulo: "Automação de processos",
    descricao:
      "Reduza tarefas repetitivas, organize fluxos de trabalho e conecte etapas que hoje dependem de processos manuais.",
    tags: ["Eficiência", "Integração", "Produtividade"],
  },
  {
    numero: "05",
    icone: "fa-code",
    titulo: "Projetos sob medida",
    descricao:
      "Tem uma necessidade específica? Analisamos seu cenário e desenvolvemos uma solução alinhada aos seus objetivos.",
    tags: ["Personalização", "Consultoria", "Inovação"],
  },
  {
    numero: "06",
    icone: "fa-database",
    titulo: "Dados e integrações",
    descricao:
      "Organização de dados, comunicação entre sistemas e integração de informações para apoiar suas decisões.",
    tags: ["Banco de dados", "APIs", "Integração"],
  },
];

function Solucoes() {
  return (
    <section id="solucoes" className="secao solucoes">
      <div className="container">
        <div className="secao-cabecalho">
          <span className="sobretitulo">O QUE FAZEMOS</span>

          <h2>
            Tecnologia que faz
            <span className="texto-destaque"> sentido para você.</span>
          </h2>

          <p>
            Cada negócio tem seus desafios. Criamos soluções digitais
            considerando a realidade, as necessidades e os objetivos
            de cada cliente.
          </p>
        </div>

        <div className="solucoes-grid">
          {solucoes.map((solucao) => (
            <article className="solucao-card" key={solucao.numero}>
              <div className="solucao-topo">
                <span className="solucao-icone">
                  <i className={`fas ${solucao.icone}`} aria-hidden="true" />
                </span>
                <span className="solucao-numero">{solucao.numero}</span>
              </div>

              <h3>{solucao.titulo}</h3>
              <p>{solucao.descricao}</p>

              <div className="solucao-tags">
                {solucao.tags.map((tag) => (
                  <span key={tag}>{tag}</span>
                ))}
              </div>

              <a href="#contato" className="solucao-link">
                Vamos conversar <span aria-hidden="true">↗</span>
              </a>
            </article>
          ))}
        </div>

        <div className="solucoes-nota">
          <span className="nota-icone">✳</span>
          <p>
            <strong>Não encontrou exatamente o que precisa?</strong>
            <br />
            Conte sua ideia. Podemos desenvolver uma solução específica
            para o seu negócio.
          </p>
          <a href="#contato" className="btn-nota">
            Falar sobre meu projeto <span aria-hidden="true">↗</span>
          </a>
        </div>
      </div>
    </section>
  );
}

export default Solucoes;
